import Vue from "vue";

export default {
	state: {
		contacts: []
	},
	mutations: {
		setContactsOnState(state, contacts) {
			state.contacts = contacts;
		}
	},
	actions: {
		getSupplierContacts({ commit }, idSupplier) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("supplierClientContact/" + idSupplier)
					.then((response) => {
						commit("setContactsOnState", response.data.data);
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		deleteContactSupplier(_, idContact) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.delete("SupplierClientContact/" + idContact)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getSupplierContactsByIdClient(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("SupplierClientContact/" + data.idSupplier + "/" + data.idClient)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		createContactSupplier(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("SupplierClientContact/", data)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		updateContactSupplier(_, data) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("SupplierClientContact/", data)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		}
	},
	getters: {
		supplierContacts({ contacts }) {
			return contacts;
		}
	}
};
